import {get} from 'lodash';

import {getCacheKey} from '/util/records.util';

export default (
  state = {},
  {reportName, reportParams, data, reportKey}: any,
) => {
  const key =
    reportKey ||
    getCacheKey({
      recordsName: reportName,
      recordsParams: reportParams,
    });

  return {
    ...state,
    allReportData: {
      ...get(state, 'allReportData', {}),
      [key]: data,
    },
  };
};
